
export default function TAB_OTHERS({ domain }) {
  const provider = domain?.extractions?.provider;
  return (
    <div>
      <p>Social: {provider?.social?.facebook}</p>
      <p>Camps: {provider?.offerings?.camps ? 'Yes' : 'No'}</p>
      <p>Wheelchair Accessible: {provider?.accessibility?.wheelchairAccessible ? 'Yes' : 'No'}</p>
    </div>
  );
}